/**
 * Copyright (c) 2026 Spicy Friends Ltd.
 * All rights reserved.
 *
 * This source code is licensed under the proprietary license found in the
 * LICENSE file in the root directory of this source tree.
 */

import { Button } from '@repo/shared-client/components/ui'
import { Link as TanStackLink } from '@tanstack/react-router'
import { useTranslation } from '@web/src/lib/intl/react'

type PlacesMenuProps = {
  activeTab?: string
  categoriesRoute?: string
  listRoute?: string
}

const PlacesMenu = ({
  activeTab = 'discover',
  categoriesRoute = '/place',
  listRoute = '/place/list',
}: PlacesMenuProps) => {
  const { t } = useTranslation()

  return (
    <div className="flex items-center justify-center gap-2">
      <Button
        nativeButton={false}
        render={<TanStackLink to={categoriesRoute} />}
        variant={activeTab === 'categories' ? 'pill' : 'pill-outline'}
      >
        {t('Categories')}
      </Button>
      <Button
        nativeButton={false}
        render={<TanStackLink to={listRoute} />}
        variant={activeTab === 'discover' ? 'pill' : 'pill-outline'}
      >
        {t('Discover')}
      </Button>
    </div>
  )
}

export default PlacesMenu
